import { render, staticRenderFns } from "./FooterApplis.vue?vue&type=template&id=177983b3&scoped=true"
import script from "./FooterApplis.vue?vue&type=script&lang=js"
export * from "./FooterApplis.vue?vue&type=script&lang=js"
import style0 from "./FooterApplis.vue?vue&type=style&index=0&id=177983b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177983b3",
  null
  
)

export default component.exports